import jquery from "jquery";
// @ts-ignore
window.jQuery = jquery;
// @ts-ignore
window.$ = jquery;
